<template>
  <div>
    <div class="container-fluid mt-3">
      <div class="row mb-5">
        <div class="col">
          <div class="card shadow" :class="''">
            <div class="card-header border-0" :class="''">
              <div class="row align-items-center">
                <div class="col-md-3">
                  <h3 class="mb-0" :class="''">
                    Question paper
                  </h3>
                </div>
                <div class="col-md-9 text-right">
                  <select  aria-describedby="addon-right addon-left" class="form-control w-auto mr-2 d-inline" autocomplete="off" v-model="selectclass" @change="getfilterdata()">
                    <option value="">Select class</option>
                    <option v-for="classes in classesData" :key="classes.class_id" :value="classes._id">{{classes.class_name}}</option>
                  </select>
                  <select  aria-describedby="addon-right addon-left" class="form-control w-auto mr-2 d-inline" autocomplete="off" v-model="selectexam" @change="getfilterdata()">
                    <option value="">Select exam session</option>
                    <option v-for="exam in examData" :key="exam.exam_id" :value="exam._id">{{exam.exam_name}}</option>
                  </select>
                  <base-button type="primary" @click="addquestionpaperpopup"><i class="fas fa-plus"></i> Create question paper</base-button>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <base-table class="table align-items-center table-flush" :class="''" :thead-classes="'thead-light'" tbody-classes="list" :data="questionpaperData">
                <template slot="columns">
                  <th>S. No.</th>
                  <th>question paper title</th>
                  <th>exam</th>
                  <th>class</th>
                  <th>status</th>
                  <th class="text-right">Actions</th>
                </template>
                <template slot-scope="{row,index}">
                    <td class="budget">
                      <p class="mb-0">{{index+1}}</p>
                    </td>
                    <td class="budget">
                      {{row.question_paper_title}}
                    </td>
                    <td class="budget">
                      <p class="mb-0" v-if="row.exam_oid">{{row.exam_oid.exam_name}}</p>
                    </td>
                    <td class="budget">
                      <p class="mb-0" v-if="row.class_oid">{{row.class_oid.class_name}}</p>
                    </td>
                    <td class="budget">
                      <p class="mb-0">{{row.question_paper_status}}</p>
                    </td>
                    <td class="text-right">
                      <base-button type="primary" size="sm" @click="editquestionpaperpopup(row)" >Edit</base-button>
                      <base-button type="danger" size="sm" @click="deletequestionpaper(row)">Delete</base-button>
                      <!-- <router-link class="btn btn-primary btn-sm" to="/seo/meta" icon="fa fa-info">View</router-link> -->
                    </td>
                </template>
              </base-table>

              <!-- no data found here -->
              <div class="card-footer justify-content-center" v-if="datanotfound">
                <div class="col-md-3 mx-auto mt-4 text-center">
                    <img src="/img/theme/no-result.png" class="img-fluid">
                    <p class="mt-4">No question paper created.</p>
                </div>
              </div>
              <!-- shimmer starts here -->
              <div class="col-md-12" v-if="questionpaperData.length==0 && !datanotfound">
                <div class="row justify-content-center">
                  <div class="col-lg-12 mt-3">
                      <div class="card border-0 shadow">
                         <div class="card-body pt-2 pb-1">
                              <div class="row">
                                  <div class="col-md-3 col-3 mt-1 mb-1">
                                      <span class="circle-shimmer shine"></span>
                                  </div>
                                  <div class="col-md-9 col-9 mt-1 mb-1">
                                      <div class="div-shimmer w-100 mt-0 pr-4">
                                        <span class="line-shimmer w-100 shine"></span>
                                        <span class="line-shimmer w-100 shine"></span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-lg-12">
                      <div class="card border-0 shadow">
                         <div class="card-body pt-2 pb-1">
                              <div class="row">
                                  <div class="col-md-3 col-3 mt-1 mb-1">
                                      <span class="circle-shimmer shine"></span>
                                  </div>
                                  <div class="col-md-9 col-9 mt-1 mb-1">
                                      <div class="div-shimmer w-100 mt-0 pr-4">
                                        <span class="line-shimmer w-100 shine"></span>
                                        <span class="line-shimmer w-100 shine"></span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-lg-12">
                      <div class="card border-0 shadow">
                         <div class="card-body pt-2 pb-1">
                              <div class="row">
                                  <div class="col-md-3 col-3 mt-1 mb-1">
                                      <span class="circle-shimmer shine"></span>
                                  </div>
                                  <div class="col-md-9 col-9 mt-1 mb-1">
                                      <div class="div-shimmer w-100 mt-0 pr-4">
                                        <span class="line-shimmer w-100 shine"></span>
                                        <span class="line-shimmer w-100 shine"></span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-lg-12">
                      <div class="card border-0 shadow">
                         <div class="card-body pt-2 pb-1">
                              <div class="row">
                                  <div class="col-md-3 col-3 mt-1 mb-1">
                                      <span class="circle-shimmer shine"></span>
                                  </div>
                                  <div class="col-md-9 col-9 mt-1 mb-1">
                                      <div class="div-shimmer w-100 mt-0 pr-4">
                                        <span class="line-shimmer w-100 shine"></span>
                                        <span class="line-shimmer w-100 shine"></span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                </div>
              </div>
              <!-- shimmer ends here -->
            </div>
            <!-- <div class="card-footer d-flex justify-content-end"  :class="type === 'dark' ? 'bg-transparent': ''">
              <base-pagination :total="30"></base-pagination>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- add baner -->
    <modal :show.sync="addquestionpaper">
      <p
        id="modal-title-default"
        slot="header"
        class="modal-title"
      >
        <span>Create question paper</span>
      </p>
      <template>
        <form @submit.prevent>
          <div class="row mt--3">
            <div class="col-lg-12">
              <label class="form-control-label">Question paper title<span class="text-danger">*</span></label>
              <base-input placeholder="Question paper title" v-model="questionpapermodal.question_paper_title" input-classes="" class="form-group-mb0" />
              <div
                  v-if="$v.questionpapermodal.question_paper_title.$error"
                  class="error h5 text-danger mt-1 pl-1"
                >
                  Field is required.
              </div>
            </div>
             <div class="col-lg-12">
              <label class="form-control-label">Question paper upload<span class="text-danger">*</span></label>
                <input
                  id="file"
                  ref="myFiles"
                  type="file"
                  aria-describedby="addon-right addon-left"
                  alternative=""
                  class="form-control form-control-alternative"
                  name="img"
                  @change="hadleimage($event,'add')"
                >
                <div
                  v-if="$v.questionpapermodal.question_paper_link.$error"
                  class="error h5 text-danger mt-1 pl-1"
                >
                  Field is required.
              </div>
                <base-progress type="success" v-model="uploadPercentage" label="File uploaded"></base-progress>
                <div>
                  <img :src="questionpapermodal.question_paper_link" class="img-fluid rounded shadow mt-2">
                </div>
                <br>
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">Question paper creator<span class="text-danger">*</span></label>
              <select  aria-describedby="addon-right addon-left" class="form-control" autocomplete="off" v-model="questionpapermodal.question_paper_setter">
                <option value="">Select teacher</option>
                <option v-for="teacher in teacherData" :key="teacher.user_id" :value="teacher._id">{{teacher.user_name}}</option>
              </select>
              <div
                  v-if="$v.questionpapermodal.question_paper_setter.$error"
                  class="error h5 text-danger mt-1 pl-1"
                >
                  Field is required.
              </div>
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">Class<span class="text-danger">*</span></label>
              <select  aria-describedby="addon-right addon-left" class="form-control" autocomplete="off" v-model="questionpapermodal.class_oid" @change="getsubjectbyclass('add')">
                <option value="">Select class</option>
                <option v-for="classes in classesData" :key="classes.class_id" :value="classes._id">{{classes.class_name}}</option>
              </select>
              <div
                  v-if="$v.questionpapermodal.class_oid.$error"
                  class="error h5 text-danger mt-1 pl-1"
                >
                  Field is required.
              </div>
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">Subject<span class="text-danger">*</span></label>
              <select  aria-describedby="addon-right addon-left" class="form-control" autocomplete="off" v-model="questionpapermodal.subject_oid">
                <option value="">Select subject</option>
                <option v-for="subject in subjectData" :key="subject.subject_id" :value="subject._id">{{subject.subject_name}}</option>
              </select>
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">Exam<span class="text-danger">*</span></label>
              <select  aria-describedby="addon-right addon-left" class="form-control" autocomplete="off" v-model="questionpapermodal.exam_oid">
                <option value="">Select exam</option>
                <option v-for="exam in examData" :key="exam.exam_id" :value="exam._id">{{exam.exam_name}}</option>
              </select>
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">Download from<span class="text-danger">*</span></label>
              <base-input type="datetime-local" placeholder="Download from" v-model="questionpapermodal.download_from" input-classes="" class="form-group-mb0" />
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">Download to<span class="text-danger">*</span></label>
              <base-input type="datetime-local" placeholder="Download to" v-model="questionpapermodal.download_to" input-classes="" class="form-group-mb0" />
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">Status<span class="text-danger">*</span></label>
              <select  aria-describedby="addon-right addon-left" class="form-control" autocomplete="off" v-model="questionpapermodal.question_paper_status">
                <option value="approved">approved</option>
                <option value="disapproved">disapproved</option>
              </select>
              <div
                  v-if="$v.questionpapermodal.question_paper_status.$error"
                  class="error h5 text-danger mt-1 pl-1"
                >
                  Field is required.
              </div>
            </div>
          </div>
        </form>
      </template>

      <template slot="footer">
        <base-button
         :disabled="$v.questionpapermodal.$error" @click="$v.questionpapermodal.$touch();createquestionpaper()"
          type="success"
          id="createquestionpaperbtn"
          class="float-center"
        >
          <span>Save questionpaper</span>
        </base-button>
        <base-button
          type="link"
          class="ml-auto"
          @click="addquestionpaper = false"
        >
          <span>Close</span>
        </base-button>
      </template>
    </modal>
    <!-- edit banner popup -->
    <modal :show.sync="editquestionpaper">
      <p
        id="modal-title-default"
        slot="header"
        class="modal-title"
      >
        <span>Edit question paper</span>
      </p>
      <template>
        <form @submit.prevent>
          <div class="row mt--3">
            <div class="col-lg-12">
              <label class="form-control-label">Question paper title<span class="text-danger">*</span></label>
              <base-input placeholder="Question paper title" v-model="editquestionpapermodal.question_paper_title" input-classes="" class="form-group-mb0" />
              <div
                  v-if="$v.editquestionpapermodal.question_paper_title.$error"
                  class="error h5 text-danger mt-1 pl-1"
                >
                  Field is required.
              </div>
            </div>
             <div class="col-lg-12">
              <label class="form-control-label">Question paper upload<span class="text-danger">*</span></label>
                <input
                  id="file"
                  ref="myFiles"
                  type="file"
                  aria-describedby="addon-right addon-left"
                  alternative=""
                  class="form-control form-control-alternative"
                  name="img"
                  @change="hadleimage($event,'edit')"
                >
                <div
                  v-if="$v.editquestionpapermodal.question_paper_link.$error"
                  class="error h5 text-danger mt-1 pl-1"
                >
                  Field is required.
              </div>
                <base-progress type="success" v-model="uploadPercentage" label="File uploaded"></base-progress>
                <div>
                  <img :src="editquestionpapermodal.question_paper_link" class="img-fluid rounded shadow mt-2">
                </div>
                <br>
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">Question paper creator<span class="text-danger">*</span></label>
              <select  aria-describedby="addon-right addon-left" class="form-control" autocomplete="off" v-model="editquestionpapermodal.question_paper_setter">
                <option value="">Select teacher</option>
                <option v-for="teacher in teacherData" :key="teacher.user_id" :value="teacher._id">{{teacher.user_name}}</option>
              </select>
              <div
                  v-if="$v.editquestionpapermodal.question_paper_setter.$error"
                  class="error h5 text-danger mt-1 pl-1"
                >
                  Field is required.
              </div>
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">Class<span class="text-danger">*</span></label>
              <select  aria-describedby="addon-right addon-left" class="form-control" autocomplete="off" v-model="editquestionpapermodal.class_oid" @change="getsubjectbyclass('edit')">
                <option value="">Select class</option>
                <option v-for="classes in classesData" :key="classes.class_id" :value="classes._id">{{classes.class_name}}</option>
              </select>
              <div
                  v-if="$v.editquestionpapermodal.class_oid.$error"
                  class="error h5 text-danger mt-1 pl-1"
                >
                  Field is required.
              </div>
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">Subject<span class="text-danger">*</span></label>
              <select  aria-describedby="addon-right addon-left" class="form-control" autocomplete="off" v-model="editquestionpapermodal.subject_oid">
                <option value="">Select subject</option>
                <option v-for="subject in subjectData" :key="subject.subject_id" :value="subject._id">{{subject.subject_name}}</option>
              </select>
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">Exam<span class="text-danger">*</span></label>
              <select  aria-describedby="addon-right addon-left" class="form-control" autocomplete="off" v-model="editquestionpapermodal.exam_oid">
                <option value="">Select exam</option>
                <option v-for="exam in examData" :key="exam.exam_id" :value="exam._id">{{exam.exam_name}}</option>
              </select>
            </div>
            
            <div class="col-lg-12">
              <label class="form-control-label">Download from<span class="text-danger">*</span></label>
              <base-input type="datetime-local" placeholder="Download from" v-model="editquestionpapermodal.download_from" input-classes="" class="form-group-mb0" />
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">Download to<span class="text-danger">*</span></label>
              <base-input type="datetime-local" placeholder="Download to" v-model="editquestionpapermodal.download_to" input-classes="" class="form-group-mb0" />
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">Status<span class="text-danger">*</span></label>
              <select  aria-describedby="addon-right addon-left" class="form-control" autocomplete="off" v-model="editquestionpapermodal.question_paper_status">
                <option value="approved">approved</option>
                <option value="disapproved">disapproved</option>
              </select>
              <div
                  v-if="$v.editquestionpapermodal.question_paper_status.$error"
                  class="error h5 text-danger mt-1 pl-1"
                >
                  Field is required.
              </div>
            </div>
          </div>
        </form>
      </template>

      <template slot="footer">
        <base-button
          :disabled="$v.editquestionpapermodal.$error" @click="$v.editquestionpapermodal.$touch();updatequestionpaper()"
          type="success"
          id="updatequestionpaperbtn"
          class="float-center"
        >
          <span>Update questionpaper</span>
        </base-button>
        <base-button
          type="link"
          class="ml-auto"
          @click="editquestionpaper = false"
        >
          <span>Close</span>
        </base-button>
      </template>
    </modal>

  </div>
</template>
<script>
  // Charts
  import * as chartConfigs from '@/components/Charts/config';
  import LineChart from '@/components/Charts/LineChart';
  import BarChart from '@/components/Charts/BarChart';

  import { Tabs } from '@/components';
  import { BasePagination } from '@/components/Tabs/Tabs';

  // Components
  import DropzoneFileUpload from '@/components/Inputs/DropzoneFileUpload'
  import BaseProgress from '@/components/BaseProgress';
  // import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import StatsCard from '@/components/Cards/StatsCard';
  import { ModelListSelect } from 'vue-search-select'
  import { required, minLength, between } from 'vuelidate/lib/validators';
  import 'vue-search-select/dist/VueSearchSelect.css'
  import VueSwal from 'vue-swal';
  import axios from "axios";

  export default {
    components: {
      // ActivityFeed,
      Tabs,
      LineChart,
      BarChart,
      BaseProgress,
      StatsCard,
      // TaskList,
      // PageVisitsTable,
      // SocialTrafficTable,
      // LightTable,
      // UserList,
      // ProgressTrackList
// cayegory
// subcategory
// variation
// item
// offer
      DropzoneFileUpload,
      ModelListSelect,
    },
    data() {
      return {
        addquestionpaper: false,
        editquestionpaper: false,
        datanotfound:false,
        uploadPercentage:0,
        selectclass:'',
        selectexam:'',
        pagepermission:{},
        questionpaperData:[],
        teacherData:[],
        classesData:[],
        subjectData:[],
        examData:[],
        questionpapermodal:{
          question_paper_id : '',
          question_paper_title : '',
          question_paper_link : '',
          question_paper_setter : '',
          class_oid : '',
          exam_oid : '',
          subject_oid : '',
          question_paper_status : 'approved',
          verified : true,
          download_from : '',
          download_to : '',
        },
        editquestionpapermodal:{
          question_paper_id : '',
          question_paper_title : '',
          question_paper_link : '',
          question_paper_setter : '',
          class_oid : '',
          exam_oid : '',
          subject_oid : '',
          question_paper_status : 'approved',
          verified : true,
          download_from : '',
          download_to : '',
        },
        radios: {
          radio1: 'checked',
          radio2: 'checked'
        },
        auth : {
          headers: { 'Content-Type':'application/x-www-form-urlencoded',
          'Authorization':'caption#' + localStorage.getItem('accessToken'),
          '_id':localStorage.getItem('_id')}
        },
        auth1 : { headers: { 'Content-Type':'application/json',
          'Authorization':'caption#' + localStorage.getItem('accessToken'),
          '_id':localStorage.getItem('_id')}
        },
      };
    },
    validations: {

      questionpapermodal: {
        question_paper_title:{
          required
        },
        question_paper_link:{
          required
        },
        question_paper_setter:{
          required
        },
        question_paper_status:{
          required
        },
        class_oid:{
          required
        },
        
      },
      editquestionpapermodal: {
        question_paper_title:{
          required
        },
        question_paper_link:{
          required
        },
        question_paper_setter:{
          required
        },
        question_paper_status:{
          required
        },
        class_oid:{
          required
        },
      },

    },
    mounted() {
      this.pagepermission=JSON.parse(localStorage.getItem(this.$router.currentRoute.path));
      console.log(this.pagepermission);
      const querystring = require('querystring');
      console.log(this.auth);
      axios
      .post(process.env.VUE_APP_API_ENDPOINT+'read_question_paper',{ "details" :{}},this.auth1)
      .then(response => {
        console.log(response);
        if(response.data.details){
        this.questionpaperData=response.data.details;
        this.datanotfound=false;
        }else{
          this.questionpaperData=[];
          this.datanotfound=true;
        }
            
      })
      axios
      .post(process.env.VUE_APP_API_ENDPOINT+'read_admin',{ "details" :{"user_type":'teacher'}},this.auth1)
      .then(response => {
        console.log(response);
        if(response.data.details){
        this.teacherData=response.data.details;
        }
            
      })
      axios
      .post(process.env.VUE_APP_API_ENDPOINT+'read_class',{ "details" :{}},this.auth1)
      .then(response => {
        console.log(response);
        if(response.data.details){
        this.classesData=response.data.details;
        }
            
      })
      // axios
      // .post(process.env.VUE_APP_API_ENDPOINT+'read_subject',{ "details" :{}},this.auth1)
      // .then(response => {
      //   console.log(response);
      //   if(response.data.details){
      //     this.subjectData=response.data.details;
      //   }
            
      // })
      axios
      .post(process.env.VUE_APP_API_ENDPOINT+'read_exam',{ "details" :{exam_status:'approved'}},this.auth1)
      .then(response => {
        console.log(response);
        if(response.data.details){
          this.examData=response.data.details;
        }
            
      })
      
    },
    methods: {
      getfilterdata(){
        let details={ "details" :{}};
        if(this.selectclass){
          details.details.class_oid=this.selectclass;
        }
        if(this.selectexam){
          details.details.exam_oid=this.selectexam;
        }

        axios
        .post(process.env.VUE_APP_API_ENDPOINT+'read_question_paper',details,this.auth1)
        .then(response => {
          console.log(response);
          if(response.data.success){
          this.questionpaperData=response.data.details;
          this.datanotfound=false;
          }else{
            this.questionpaperData=[];
            this.datanotfound=true;
          }
              
        })

      },
      getsubjectbyclass(type){
        let details={ "details" :{}};
        if(type=='add'){
           details.details.class_oid=this.questionpapermodal.class_oid
        }else{
          details.details.class_oid=this.editquestionpapermodal.class_oid;
          this.editquestionpapermodal.subject_oid='';
        }
        

        axios
          .post(process.env.VUE_APP_API_ENDPOINT+'read_subject',details,this.auth1)
          .then(response => {
            console.log(response);
            if(response.data.details){
              this.subjectData=response.data.details;
            }
                
          })

      },
      addquestionpaperpopup(row){
        console.log(row);
        this.addquestionpaper=true;
      },
      editquestionpaperpopup(row){
        console.log(row);
          this.editquestionpapermodal.question_paper_id =row.question_paper_id
          this.editquestionpapermodal.question_paper_title =row.question_paper_title
          this.editquestionpapermodal.question_paper_link =row.question_paper_link
          if(row.question_paper_setter){
          this.editquestionpapermodal.question_paper_setter =row.question_paper_setter._id;
          }
          if(row.class_oid){
          this.editquestionpapermodal.class_oid =row.class_oid._id;
          }
          if(row.exam_oid){
          this.editquestionpapermodal.exam_oid =row.exam_oid._id;
          }
          if(row.subject_oid){
          this.editquestionpapermodal.subject_oid =row.subject_oid._id;
          }
          this.editquestionpapermodal.question_paper_status =row.question_paper_status;
          if(row.download_from){
            let dfrom=row.download_from.split(':00.');
            this.editquestionpapermodal.download_from =dfrom[0];
          }
          if(row.download_to){
            let tfrom=row.download_to.split(':00.');
            this.editquestionpapermodal.download_to =tfrom[0];
          }
          let details={ "details" :{}};
          details.details.class_oid=this.editquestionpapermodal.class_oid;
          axios
          .post(process.env.VUE_APP_API_ENDPOINT+'read_subject',details,this.auth1)
          .then(response => {
            console.log(response);
            if(response.data.details){
              this.subjectData=response.data.details;
            }
                
          })

          this.editquestionpaper=true;

      },
      hadleimage: function(event,type) {
            // Reference to the DOM input element
            this.uploadPercentage =0;
            var input = event.target;
            // Ensure that you have a file before attempting to read it
            if(input.files[0].size < 5000000){

            const fd= new FormData();
            fd.append('image',input.files[0],input.files[0].name);
            axios
            .post(process.env.VUE_APP_API_ENDPOINT+'image-upload',fd,{ headers: {'Content-Type': 'multipart/form-data'},onUploadProgress: function( progressEvent ) { this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) ); console.log(this.uploadPercentage)}.bind(this)})
            .then(response => {
              console.log(response);
              if(type=='add'){
                this.questionpapermodal.question_paper_link=response.data.imageUrl;
                console.log(this.questionpapermodal.question_paper_link);
              }if(type=='edit'){
                this.editquestionpapermodal.question_paper_link=response.data.imageUrl;
                console.log(this.questionpapermodal.question_paper_link);
              }
                
            })

            }else{

            swal({
              title:'File too large!',
              text: 'Your file is larger than 5 MB. Please upload images which are less than 5 MB.',
              icon:'warning',
             }).then((result) => {
               
            })

          }

    },
    createquestionpaper(){
        if(this.$v.questionpapermodal.$error===false){
        const querystring = require('querystring');
           axios.post(process.env.VUE_APP_API_ENDPOINT+'create_question_paper',querystring.stringify({question_paper_title : this.questionpapermodal.question_paper_title,question_paper_link:this.questionpapermodal.question_paper_link,teacher_oid:this.questionpapermodal.question_paper_setter,class_oid:this.questionpapermodal.class_oid,exam_oid:this.questionpapermodal.exam_oid,subject_oid:this.questionpapermodal.subject_oid,question_paper_status:this.questionpapermodal.question_paper_status,verified:this.questionpapermodal.verified,download_from:this.questionpapermodal.download_from,download_to:this.questionpapermodal.download_to}),this.auth)
          .then(response => {
            console.log(response);
            this.message=response.data.message;
            document.getElementById("createquestionpaperbtn").classList.remove('btn-primary');
            document.getElementById("createquestionpaperbtn").classList.add('btn-success');
            document.getElementById("createquestionpaperbtn").innerHTML='Updated';
            setTimeout(function(){
            document.getElementById("createquestionpaperbtn").classList.remove('btn-success');
            document.getElementById("createquestionpaperbtn").classList.add('btn-primary');
            document.getElementById("createquestionpaperbtn").innerHTML="Update";
            window.location.reload()
          }, 2000);

          })
        }
        
      },
      updatequestionpaper(){
        if(this.$v.editquestionpapermodal.$error===false){
        const querystring = require('querystring');
           axios.post(process.env.VUE_APP_API_ENDPOINT+'update_question_paper',querystring.stringify({question_paper_id : this.editquestionpapermodal.question_paper_id,question_paper_title : this.editquestionpapermodal.question_paper_title,question_paper_link:this.editquestionpapermodal.question_paper_link,teacher_oid:this.editquestionpapermodal.question_paper_setter,class_oid:this.editquestionpapermodal.class_oid,exam_oid:this.editquestionpapermodal.exam_oid,subject_oid:this.editquestionpapermodal.subject_oid,question_paper_status:this.editquestionpapermodal.question_paper_status,verified:this.editquestionpapermodal.verified,download_from:this.editquestionpapermodal.download_from,download_to:this.editquestionpapermodal.download_to}),this.auth)
          .then(response => {
            console.log(response);
            this.message=response.data.message;
            document.getElementById("updatequestionpaperbtn").classList.remove('btn-primary');
            document.getElementById("updatequestionpaperbtn").classList.add('btn-success');
            document.getElementById("updatequestionpaperbtn").innerHTML='Updated';
            setTimeout(function(){
            document.getElementById("updatequestionpaperbtn").classList.remove('btn-success');
            document.getElementById("updatequestionpaperbtn").classList.add('btn-primary');
            document.getElementById("updatequestionpaperbtn").innerHTML="Update";
            window.location.reload()
          }, 2000);
          })

        }
        
      },
      deletequestionpaper(row) {
      console.log(row);
      const querystring = require('querystring');
        swal({
            title: 'Are you sure?',
            text: "wan't to delete",
            icon: 'warning',
            buttons: {cancel: true,confirm: true,}
        }).then((result) => { // <--
          if (result) {
            console.log('result cloud',result)
            axios.post(process.env.VUE_APP_API_ENDPOINT+'delete_question_paper',querystring.stringify({question_paper_id :row.question_paper_id}),this.auth)
          .then(response => {
            console.log(response);
            swal({
              title:'Deleted!',
              text: 'Your file has been deleted.',
              icon:'success',
             }).then((result) => {
              console.log(result)
              window.location.reload()
            })
            })
           }
        });
      },
      getstore_name(val){
        const search = this.storeData.find(element => element.store_id === val);
        if(search){
          return search.store_name;
        }
      },
    },
    
  };
</script>
<style>
  .search-input .form-group {
    display: inline-block;
    margin-bottom: 0px;
  }
</style>
